import React, { useState } from "react"
import { InternalIcon, Link, Typography, SurfaceColor, Button, Box } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as RouterLink, useHistory } from "react-router-dom"
import { CarrotCardCostSharePreAuth } from "#/components/carrot-card-cost-share"
import { DbgPaths } from "#/utils/Paths"
import { CarrotCardModuleTemplate } from "#/components/views/molecules/carrotcardmodules/carrot-card-module-template"
import CardStates from "#/utils/CardStates"

export function CarrotCardPreAuthModule({
  openPreAuth = false
}: {
  openPreAuth?: boolean
  color?: SurfaceColor
}): JSX.Element | null {
  const [showCarrotCardCostSharePreAuthDialog, setShowCarrotCardCostSharePreAuthDialog] = useState(false)
  const history = useHistory()
  return (
    <CarrotCardModuleTemplate
      cardState={CardStates.PRE_AUTH}
      title={
        <FormattedMessage defaultMessage="Carrot Card®" description="Title for Carrot Card pre-authorization module" />
      }
      body={
        <>
          <Typography>
            <FormattedMessage defaultMessage="Submit an authorization if you're ready to use your card. You can only submit one at a time." />
          </Typography>
          <Typography>
            <FormattedMessage defaultMessage="Please ask your provider for the exact transaction amount including taxes and fees." />
          </Typography>
        </>
      }
      links={[
        <React.Fragment key="carrot-card-authorize-card-link">
          {openPreAuth && (
            <Box>
              <Link
                component="button"
                onClick={() => setShowCarrotCardCostSharePreAuthDialog(true)}
                endIcon={<InternalIcon color="primary" fontSize="small" />}
              >
                <FormattedMessage defaultMessage="Authorize card" />
              </Link>
            </Box>
          )}
        </React.Fragment>,

        <Link
          component={RouterLink}
          to={DbgPaths.CARROT_CARD}
          key="carrot-card-learn-more"
          endIcon={<InternalIcon color="primary" fontSize="small" />}
        >
          <FormattedMessage defaultMessage="Learn more about Carrot Card" />
        </Link>,
        <Link
          component={RouterLink}
          to="/talk-to-carrot/sendmessage/stolen"
          key="carrot-card-report-lost-stolen"
          endIcon={<InternalIcon color="primary" fontSize="small" />}
        >
          <FormattedMessage defaultMessage="Report lost or stolen card" />
        </Link>,
        <React.Fragment key="carrot-card-authorize-card-cta">
          {!openPreAuth && (
            <Button variant="outlined" color="secondary" size="small" onClick={() => history.push("/transactions")}>
              <FormattedMessage defaultMessage="Authorize card" />
            </Button>
          )}
        </React.Fragment>,
        <CarrotCardCostSharePreAuth
          key="carrot-card-cost-share-pre-auth"
          open={showCarrotCardCostSharePreAuthDialog}
          onClose={() => setShowCarrotCardCostSharePreAuthDialog(false)}
        />
      ]}
    />
  )
}
